const UPDATE_CHECK_INTERVAL_IN_MS = 1000 * 60 * 30;

let hasPageRefreshedAfterUpdate = false;

export function registerServiceWorker(): void {
  const canRegisterServiceWorker =
    !import.meta.env.DEV && window.isSecureContext && 'serviceWorker' in navigator;

  if (!canRegisterServiceWorker) {
    return;
  }

  window.addEventListener('load', () => {
    void registerAndTrackServiceWorker();
  });
}

async function registerAndTrackServiceWorker(): Promise<void> {
  const basePath = import.meta.env.BASE_URL;
  const serviceWorkerUrl = `${basePath}admin-sw.js`;

  try {
    const registration = await navigator.serviceWorker.register(serviceWorkerUrl, {
      scope: basePath,
    });

    attachUpdateHandlers(registration);
    promptToUpdateIfWaiting(registration);
    startPeriodicUpdateChecks(registration);
  } catch (error) {
    console.error('Falha ao registrar Service Worker do admin:', error);
  }
}

function attachUpdateHandlers(registration: ServiceWorkerRegistration): void {
  registration.addEventListener('updatefound', () => {
    const installingWorker = registration.installing;
    if (!installingWorker) {
      return;
    }

    installingWorker.addEventListener('statechange', () => {
      const isNewVersionInstalled =
        installingWorker.state === 'installed' && Boolean(navigator.serviceWorker.controller);

      if (isNewVersionInstalled) {
        promptToUpdateIfWaiting(registration);
      }
    });
  });

  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (hasPageRefreshedAfterUpdate) {
      return;
    }

    hasPageRefreshedAfterUpdate = true;
    window.location.reload();
  });
}

function promptToUpdateIfWaiting(registration: ServiceWorkerRegistration): void {
  const waitingWorker = registration.waiting;
  if (!waitingWorker) {
    return;
  }

  const shouldReload = window.confirm(
    'Uma nova versao do painel admin esta disponivel. Deseja atualizar agora?'
  );

  if (shouldReload) {
    waitingWorker.postMessage({ type: 'SKIP_WAITING' });
  }
}

function startPeriodicUpdateChecks(registration: ServiceWorkerRegistration): void {
  window.setInterval(() => {
    void registration.update();
  }, UPDATE_CHECK_INTERVAL_IN_MS);
}
